import React from "react";
import "./SpaceKoPanel.scss";
import { useTranslation } from "react-i18next";
import { AspectRatio, CurrencySign, nFormatter } from "../api/ReplayVariables";
import { tokenLevel, MIN_RATIO, MAX_RATIO } from "../api/SpaceKoToken";

/**
 * v2-1379 : le jeton du heros, affiche en permanence et toujours au meme endroit, comme sur
 * la table de Winamax.
 *
 * Les trois montants disent ce que rapporterait l'elimination du heros a celui qui la
 * reussirait : au minimum 0,4 fois son jeton, en moyenne sa valeur meme, au maximum 100 fois.
 * Ce sont les trois chiffres du widget de Winamax, et le rapport du minimum est corrobore par
 * les 46 eliminations relevees dans les historiques du ticket V2-1377.
 *
 * Le bandeau disparait de lui-meme hors Space KO, et quand le heros n'a pas de prime : le
 * palier vaut alors 0. Les mains importees avant janvier 2022 sont dans ce cas, leur log
 * normalise ne portant pas encore la prime.
 */
function SpaceKoPanel({ bounty, buyIn, currency, realTableRatio }) {
  const { t } = useTranslation();
  const level = tokenLevel(bounty, buyIn);
  if (level === 0) {
    return <></>;
  }
  const sign = CurrencySign[currency] || "";
  const rows = [
    ["Min", bounty * MIN_RATIO],
    [t("replayApp.spaceKoAvg"), bounty],
    ["Max", bounty * MAX_RATIO]
  ];
  return (
    <div
      className={"space-ko-panel space-ko-panel-" + level}
      style={{ fontSize: AspectRatio.refFontSize * realTableRatio + "px" }}
    >
      <div className="sk-head">
        <span className="sk-token" />
        <span className="sk-label">
          {t("replayApp.spaceKoLevel")} {level}
        </span>
      </div>
      {rows.map(function (row) {
        return (
          <div className="sk-line" key={row[0]}>
            <span className="sk-name">{row[0]}</span>
            <span className="sk-value">
              {nFormatter(row[1])} {sign}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default SpaceKoPanel;
